
import { defineComponent, onMounted, ref } from 'vue'

import PSelect from '@/retail/application/presenters/PSelect/PSelect.vue'
import PSidebar from '@invivodf/common/src/application/presenters/PSidebar/PSidebar.vue'
import PBoToast from '@invivodf/common/src/application/presenters/PBoToast/PBoToast.vue'
import { useAuthentication } from '@/retail/contexts/user/application/composables/useAuthentication'
import { provideToastNotification } from '@invivodf/common/src/application/composables'
import { useRetailNavigationLinks } from '@/contexts/menu/application/composables/useRetailNavigationLinks'

export default defineComponent({
  name: 'VLayoutDefault',
  components: {
    PSelect,
    PSidebar,
    PBoToast,
  },
  setup() {
    provideToastNotification()

    const { logout } = useAuthentication()
    const { allowedNavigationLinks, loadRetailNavigationLinks } = useRetailNavigationLinks()
    const hasOpenSidebar = ref(false)

    const sidebarBrandData = {
      current: 'jardiland',
      items: [
        {
          icon: 'logo-jardiland',
          id: 'jardiland',
          label: 'Jardiland',
        },
        {
          icon: 'logo-gamm-vert',
          id: 'gamm-vert',
          label: 'Gamm Vert',
        },
        {
          icon: 'logo-aladin',
          id: 'aladin',
          label: 'Aladin',
        },
      ],
    }

    onMounted(async () => {
      await loadRetailNavigationLinks()
    })

    return {
      hasOpenSidebar,
      mainNavigationlinks: allowedNavigationLinks,
      sidebarBrandData,
      logout,
    }
  },
  methods: {
    onSidebarOpen(value): void {
      this.hasOpenSidebar = value
    },
    onLogout(): void {
      this.logout()
    },
  },
})
